export { PageRoleGroupsComponent as PageRoleGroups } from './component';



// WEBPACK FOOTER //
// ./src/pages/role-groups/index.tsx